<template>
  <div class="box5">
    <div class="top-box">
      <pageTitle 
        title="工商管理硕士"
        text="Master of Business Administration" />
      <p>工商管理硕士(MBA)致力于培养工商企业和经济管理部门高层管理工作所需的务实型、复合型和应用型管理人才。课程设置包含商业管理中的核心内容，课程体系覆盖战略、市场营销、财务、金融、运营、领导力、组织行为、商务谈判，以及创业、并购、VC/PE等各方面。优质的MBA课程能够为学员建构一套完备的知识体系，为其顺利晋升到管理相关的工作职能做好全面充分的准备。</p>  
    </div>
    <div class="content-box">
      <div class="title-btn">课程内容</div>
      <div class="title-text">伊利诺伊理工大学工商管理硕士毕业需完成12门<br/>课程36学分的学习</div>
      <div class="list-box">
        <div class="list-item" v-for="(item, index) in list" :key="index">
          <div class="left-code">{{ item.code }}</div>
          <div class="right-text">
            <div class="name">{{ item.name }}</div>
            <div class="description">{{ item.description }}</div>
          </div>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  components: {
    pageTitle,
    swiper,
    swiperSlide,
  },
  mounted() {},

  data() {
    return {
      list: [
        {
          code: 'BUSS10',
          name: '商业战略和创新',
          description: 'Strategy and Innovation'
        },
        {
          code: 'MBA505',
          name: '微观经济学与博弈论',
          description: 'Microeconomics and Game Theory'
        },
        {
          code: 'MBA501',
          name: '财务报表应用',
          description: 'Financial Statement Applications'
        },
        {
          code: 'MBA511',
          name: '营销策略',
          description: 'Marketing Strategy'
        },
        {
          code: 'MBA504',
          name: '决策分析',
          description: 'Analytics for Decision Making'
        },
        {
          code: 'MBA506',
          name: '领导力与组织设计',
          description: 'Leadership and Organization Design'
        },
        {
          code: 'MBA509',
          name: '财务管理',
          description: 'Financial Management'
        },
        {
          code: 'MBA513',
          name: '运营与技术管理',
          description: 'Operations & Technology Management'
        },
        {
          code: 'BUS590',
          name: '商业战略顶点课程',
          description: 'Business Strategy Capstone'
        },
        {
          code: 'MBA 564',
          name: '全球商业战略',
          description: 'Global Business Strategy'
        },
        {
          code: 'MBA 532',
          name: '人工智能商业应用',
          description: 'Artificial lntelligence'
        },
        {
          code: 'MBA 576',
          name: '新技术创业融资',
          description: 'New Technology Ventures'
        },
      ]
    };
  },

  methods: {
    
  },
};
</script>

<style lang="less" scoped>
.box5 {
  position: relative;
  background: #F4F4FB; 
  height: 2546px;
  .top-box {
    box-sizing: border-box;
    padding: 80px 0 0;
    width: 100%;
    height: 920px;
    background: #D83F3F;
    p {
      margin-top: 32px;
      padding: 0 40px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 28px;
      color: #FFFFFF;
      line-height: 44px;
      text-align: justify;
    }
  }
  /deep/.course-title-box{
    .course-title {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 44px;
      color: #FFFFFF;
      line-height: 64px;
    }
    .course-text {
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 36px;
      color: #FFFFFF;
      line-height: 52px;
    }
  } 
  .content-box {
    padding-bottom: 24px;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 686px;
    background: #FFFFFF;
    border-radius: 24px;
    .title-btn {
      margin: 48px auto 0;
      width: 320px;
      height: 72px;
      background: #D83F3F;
      border-radius: 50px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 36px;
      color: #FFFFFF;
      line-height: 72px;
      text-align: center;
    }
    .title-text {
      margin-top: 32px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 28px;
      color: #272020;
      line-height: 44px;
      text-align: center;
    }
    .list-box {
      margin: 32px auto 0;
      padding-top: 16px;
      font-family: PingFangSC, PingFang SC;
      width: 638px;
      background: #FAFAFD;
      border-radius: 32px;
      .list-item {
        position: relative;
        padding: 24px 0;
        display: flex;
        justify-content: flex-start;
        &::after {
          position: absolute;
          content: '';
          display: block;
          bottom: 0;
          left: 0;
          right: 0;
          margin: 0 auto;
          width: 558px;
          border-bottom: 1px solid #E5E6EB;
        }
        .left-code {
          width: 138px;
          margin-left: 40px;
          font-weight: bold;
          font-size: 28px;
          color: #272020;
          line-height: 44px;
          text-align: left;
        } 
        .right-text {
          .name {
            font-weight: 400;
            font-size: 28px;
            color: #272020;
            line-height: 44px;
            text-align: left;
          }
          .description {
            font-weight: 400;
            font-size: 24px;
            color: #BC5F5F;
            line-height: 40px;
            text-align: left;
          }
        }
      }
      .list-item:last-child {
        &::after {
          display: none;
        }
      }
    }
  }
}
</style>
